<div class="transport-option-condition-editor" *ngIf="condition" [formGroup]="detailsFormGroup">

    <div class="row">
        <mat-form-field class="flex-grow" appearance="fill">
            <mat-label>
              <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.filter-administration.details-editor.transport.transport-option-condition-editor.transportoption"></sc-dictionary-label>
            </mat-label>
            <mat-select formControlName="transportOptionExternalKey" name="transportOptionExternalKey">

                <mat-option [value]="-1">
                  <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.filter-administration.details-editor.transport.transport-option-condition-editor.transportoption.none"></sc-dictionary-label>
                </mat-option>

                <ng-container *ngFor="let to of transportOptions">
                    <mat-option [value]="to.externalKey">
                      <sc-dictionary-label [dictionaryKey]="to.nameDictionaryKey"></sc-dictionary-label>
                    </mat-option>

                    <ng-container *ngFor="let child of to.transportOptions">
                        <mat-option [value]="child.externalKey">
                            &nbsp;&nbsp;
                            <sc-dictionary-label [dictionaryKey]="child.nameDictionaryKey"></sc-dictionary-label>
                        </mat-option>
                    </ng-container>

                </ng-container>

            </mat-select>
        </mat-form-field>
    </div>
</div>
